export default __webpack_public_path__ + "0cf4356f40c759de24791d3a4ae62620.svg";